import React from 'react'
import '../../styles/modal.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faXmark } from '@fortawesome/free-solid-svg-icons'

function Modal(props) {
  const {isModal = false} = props;
  const closeModal = (e) => {
    e.stopPropagation();
    if(!isModal){
      props.updateModal(false);
    }
  }
  return (
    <div className="model--wrapper" onClick={(e) => closeModal(e)}>
      <div
        className="model--container"
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        <div className="model--header" style={{padding:props.subHeaderText?'10px 15px 2px 15px ':'15px'}}>
          <div key="modal-Header" title={props.headTxt}>{props.headTxt}</div>
          {props.midTxt && <div key="modal-Middle-Header" title={props.midTxt}>{props.midTxt}</div>}
          {props.endTxt && <div key="modal-End-Header" title={props.endTxt}>{props.endTxt}</div>}
          <div style={{ cursor: 'pointer' }} onClick={(e) =>  props.updateModal(false)}>
            {' '}
            <FontAwesomeIcon icon={faXmark} size="lg" />
          </div>
        </div>
        {props.subHeaderText && <div className='model--sub--header'>{props.subHeaderText}</div>}
        {props.children}
      </div>
    </div>
  )
}

export default Modal
